/**
 * Ensure that figure is a valid number
 */
export const validateFigure = (figure: unknown): figure is number => typeof figure === 'number' && Number.isFinite(figure);

/**
 * Ensure value is not 0
 */
export const validateHasTangibleValue = (figure: number) => figure !== 0;

/**
 * A common sense helper, uses to ensure that value is a non-zero number
 */
export const validateHasTransactionalValue = (figure: unknown): figure is number => (
  validateFigure(figure) && validateHasTangibleValue(figure)
);
